import * as sessionReplay from '@amplitude/session-replay-browser';

import * as DataDogLogs from '~/lib/datadog/datadog';
import * as RudderstackClient from '~/lib/rudderstack/rudderstack-client';
import * as RudderstackReady from '~/lib/rudderstack/rudderstack-ready-api';
import * as RudderstackUtils from '~/lib/rudderstack/rudderstack-utils';
import * as CustomerUtils from '~/utils/customer';

const SESSION_REPLAY_PROP = '[Amplitude] Session Replay ID';

const initSessionReplay = () => {
  const amplitude = window.ALLBIRDS.settings.amplitude;
  if (window.ALLBIRDS.settings.amplitude.INITIALIZED === true) {
    // Session replay is already initialized. window.rudderanalytics.ready is triggered every time
    //  the customers changes  OneTrust consent option. A flag is added to avoid that
    return;
  }
  if (amplitude.sessionReplayEnabled === false || amplitude.apiKey === undefined) {
    DataDogLogs.warn(
      '[Allbirds pixel] - Amplitude - Session Replay not enabled',
      {
        amplitudeApiKey: amplitude.apiKey,
        sessionReplayEnabled: amplitude.sessionReplayEnabled,
      },
      new Error('Session Replay not enabled'),
    );
    return;
  }
  return new Promise((resolve) => {
    RudderstackReady.rudderanalyticsReadyCallback(async () => {
      const traits = RudderstackUtils.getCurrentUserTraits();
      const hasPerformanceConsent = window.ALLBIRDS.OneTrust.hasPerformanceConsent();
      if (hasPerformanceConsent) {
        const response = sessionReplay.init(amplitude.apiKey, {
          deviceId: traits.anonymousId,
          optOut: false,
          sampleRate: amplitude.sessionReplaySampleRate,
          sessionId: window.rudderanalytics.getSessionId(),
        });
        await response.promise;
      }

      const sessionReplayProperties = sessionReplay.getSessionReplayProperties();

      const HALF_A_SECOND = 500;
      // Wait for the session replay to be initialized
      setTimeout(() => {
        const sessionId = sessionReplayProperties?.[SESSION_REPLAY_PROP];
        if (!sessionId) {
          DataDogLogs.warn(
            '[Allbirds pixel] - Amplitude - [Amplitude] Session Replay ID - not found ',
            { sessionId },
            new Error('Session Replay ID not found'),
          );
          return;
        }
        const marketingQueryParams = RudderstackUtils.marketingQueryParams();
        RudderstackClient.identifyUser({
          additionalTraits: {
            fbclid: marketingQueryParams.fbclid,
            gclid: marketingQueryParams.gclid,
            msclkid: marketingQueryParams.msclkid,
            session_replay_session_id: sessionId,
          },
          email: null,
        });

        CustomerUtils.setSessionReplaySessionId(sessionId);
        window.ALLBIRDS.settings.amplitude.INITIALIZED = true;

        // Add TrackJS metadata
        if (window.TrackJS && sessionId) {
          window.TrackJS.addMetadata(SESSION_REPLAY_PROP, sessionId);
        }

        resolve();
      }, HALF_A_SECOND);
    }, RudderstackReady.CALLBACK_NAMES.AMPLITUDE_INIT_SESSION_REPLAY);
  });
};

const isProductionSite =
  window.ALLBIRDS.environment.isUsStore || window.ALLBIRDS.environment.isUkStore;
if (isProductionSite) {
  initSessionReplay();
}
